import { log } from '../logs';

export const getPlaylist = async (pageId: string, playlist: string = null): Promise<PlaylistItemRes[]> => {
  const { organisation, playlistDefaultSection } = __CONFIG__;
  const endpoint = new URL(__MATCH_VIDEO_ENDPOINT__);
  endpoint.pathname =  `/horizontal/${organisation}/${playlist || playlistDefaultSection}/${pageId}`;
  log('pixels', 'endpoint', endpoint.toString());
  try {
    const playlist = await (await fetch(endpoint.toString())).json();
    log('pixels', 'outstream playlist', playlist);
    return playlist;
  } catch (_) {
    log('pixels', 'outstream match NOT found');
    return [];
  }
};